import { FileOutlined, LinkOutlined, VideoCameraOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import React, { useState } from 'react'
import DownloadFile from './DownloadFile'
import ImageWithLoader from './ImageWithLoader'
import Preview from './Preview'

function Thumbnail({ file, onClick }) {
  if (file.thumbnailUrl) {
    return (
      <ImageWithLoader
        src={file.thumbnailUrl}
        style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
        onClick={onClick}
      />
    )
  }

  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // width: 198,
        height: '100%',
        border: '1px solid black',
        borderRadius: 4,
        padding: 30,
        cursor: 'pointer',
      }}
    >
      {file?.contentType?.includes('application') && <FileOutlined style={{ fontSize: 40 }} />}
      {file?.contentType?.includes('video') && <VideoCameraOutlined style={{ fontSize: 40 }} />}
      {!file?.contentType && <LinkOutlined style={{ fontSize: 40 }} />}
    </div>
  )
}

function File({ file, onClick }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Thumbnail file={file} onClick={onClick} />
      <div style={{ display: 'flex', gap: 4, justifyContent: 'space-between' }}>
        <div
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {file.label || ''}
        </div>
        <DownloadFile file={file} />
      </div>
    </div>
  )
}

export default function Gallery({ files, hasMore, fetchNextFiles }) {
  const [id, setId] = useState()

  if (!files) {
    return <Spin />
  }

  return (
    <>
      <Preview files={files} id={id} setId={setId} hasMore={hasMore} fetchNextFiles={fetchNextFiles} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: 8 }}>
        {files.map(f => (
          <File key={f.id} file={f} onClick={() => setId(f.id)} />
        ))}
      </div>
    </>
  )
}
